import { render, staticRenderFns } from "./Feriados.vue?vue&type=template&id=4c9497b0"
import script from "./Feriados.vue?vue&type=script&lang=js"
export * from "./Feriados.vue?vue&type=script&lang=js"
import style0 from "./Feriados.vue?vue&type=style&index=0&id=4c9497b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports